import React, { useMemo } from 'react'
import { Alert, Link, Typography } from '@barracuda-internal/bds-core'

import styles from 'components/libs/banner/BannerStyles'
import { useFormatMessage } from 'lib/localization'
import { safeUrl } from 'lib/safeUrl'

const BASE_I18N_KEY = 'ess.risky_config_banner'

export interface RiskyConfigBannerEnabledProps {
  targetUrl: string
}

const RiskyConfigBannerEnabled: React.FC<RiskyConfigBannerEnabledProps> = ({ targetUrl }) => {
  const classes = styles()
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const validatedUrl = safeUrl(targetUrl)

  return useMemo(() => {
    // Don't render if URL is potentially malicious
    if (!validatedUrl) {
      return null
    }

    return (
      <Alert className={classes.alert} severity="warning">
        {formatMessage('title')}
        <br />
        <Link className={classes.bannerLinkNewLine} href={validatedUrl}>
          <Typography variant="caption">{formatMessage('link')}</Typography>
        </Link>
      </Alert>
    )
  }, [classes.alert, classes.bannerLinkNewLine, formatMessage, validatedUrl])
}

export default RiskyConfigBannerEnabled
